exports.isLoopable = require('../is-iterable/is-iterable.js').isIterable;